import React from 'react';
import { useSelector } from 'react-redux';
import { getFirstName } from 'Shared/helpers';

import { getWorkspaceTeammateById } from 'Shared/selectors/workspace';
import ModalHeaderWithAvatar from 'Shared/components/modals/ModalsComponents/ModalHeaderWithAvatar/ModalHeaderWithAvatar';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import kudosIllustration from './kudosIllustration.png';

type Props = {
  onModalToggle?(): void;
  isGroup: boolean;
  teammateId: number;
  isEditFeedback: boolean;
  workspaceName: string;
};

const defaultAvatar = { profilePictureUrl: kudosIllustration };

export default function Header({ onModalToggle, isGroup, isEditFeedback, workspaceName, teammateId }: Props) {
  const { tr } = useTranslation();
  const teammate = useSelector(getWorkspaceTeammateById(teammateId));

  const avatar = isGroup ? null : teammate?.avatar || defaultAvatar;
  const firstName = teammate?.firstName || getFirstName(workspaceName || '') || '';

  const title = isGroup
    ? tr('perform.modals.give_recognition.title_group')
    : tr('perform.modals.give_recognition.title_individual', firstName);

  const description = isGroup
    ? tr('perform.modals.give_recognition.description_group')
    : tr('perform.modals.give_recognition.description_individual', firstName);

  return (
    <ModalHeaderWithAvatar
      onToggle={onModalToggle}
      title={isEditFeedback ? tr('perform.modals.give_recognition.edit_title') : title}
      description={description}
      avatar={avatar}
    />
  );
}
